import {
  camelizeKeys,
  decamelizeKeys,
} from 'humps';

import {
  WAG_CONTENT_API_URL,
  WagContentApiEndpoint,
} from '../../constants/endpoints';

import {
  ArticleResponse,
  CamelizedArticleResponse,
} from '../../types/api/article';
import { httpPost } from '../../wag-react/common/api/api';
import { applyPathParams } from '../../wag-react/common/api/utils/applyPathParams';

export type PostDailyWagBlogArticleCommentPayload = {
  text: string;
  name: string;
  email: string;
  imageUrls?: string[];
};
export const postDailyWagBlogArticleComment = async (
  slug:string,
  payload: PostDailyWagBlogArticleCommentPayload,
) => {
  const endpoint = applyPathParams(
    WagContentApiEndpoint.DailyWagBlogArticleComments,
  )({
    slug,
  });

  const response = await httpPost<
    PostDailyWagBlogArticleCommentPayload,
    ArticleResponse['commentList']
  >(
    endpoint,
    // TODO - Create a utility typing for decamelizing keys
    decamelizeKeys(payload) as PostDailyWagBlogArticleCommentPayload,
    {
      baseURL: WAG_CONTENT_API_URL,
    },
  );

  const camelizedResponse = camelizeKeys(response.data);
  return camelizedResponse as CamelizedArticleResponse['commentList'];
};
